/**
 * Typed API methods for axon-viewer plugin.
 */
import { request } from '@reflex/ui/client/http';
import type { AxonEvent, PublishParams, PublishResultView } from '@reflex/shared';

export interface AxonListItem {
  id: string;
  created_at_ms: number;
  name?: string | null;
  last_event_at_ms?: number;
}

interface AxonListResponse {
  axons: AxonListItem[];
  total_count?: number;
  has_more?: boolean;
}

export function listAxons(params?: {
  limit?: number;
  starting_after?: string;
}): Promise<AxonListResponse> {
  const qs = new URLSearchParams();
  if (params?.limit != null) qs.set('limit', String(params.limit));
  if (params?.starting_after) qs.set('starting_after', params.starting_after);
  const query = qs.toString();
  return request<AxonListResponse>(`/axons${query ? `?${query}` : ''}`);
}

export function getAxon(id: string): Promise<AxonListItem> {
  return request<AxonListItem>(`/axons/${encodeURIComponent(id)}`);
}

export function getAxonEvents(id: string): Promise<AxonEvent[]> {
  return request<AxonEvent[]>(`/axons/${encodeURIComponent(id)}/events`);
}

export function publishToAxon(id: string, params: PublishParams): Promise<PublishResultView> {
  return request<PublishResultView>(`/axons/${encodeURIComponent(id)}/publish`, {
    method: 'POST',
    body: JSON.stringify(params),
  });
}
